export const GOOGLE_MAPS_API_KEY = 'AIzaSyBrIDVK_fZFxi_XrA8THSn7IanTXk3gwiU';
